import React from "react";
import CouponsContainer from "../../containers/Coupons";

const CouponsPage = () => {
  return (
    <>
      <CouponsContainer />
    </>
  );
};

export default CouponsPage;
